// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { __ } from '../../../../i18n/l10n';
import { setHistoryFilter as setHistoryFilterAction } from '../../actions/history';
import GridsFilters from '../../components/buttons/GridsFilters';
import { HistoryFilters } from '../../types';

const legacySelector = memoize((state) => {
  const filters = [
    {
      id: HistoryFilters.ALL,
      label: __('All my grids'),
    },
    {
      id: HistoryFilters.RUNNING,
      label: __('!noun:GridsFilterRunning'),
    },
    {
      id: HistoryFilters.WON,
      label: __('!noun:GridsFilterWon'),
    },
    {
      id: HistoryFilters.LOST,
      label: __('!noun:GridsFilterLost'),
    },
    {
      id: HistoryFilters.CANCELLED,
      label: __('!noun:GridsFilterCancelled'),
    },
  ];
  return {
    filters,
    currentFilterId: state.grids.history.filter,
  };
});

type GridsHistoryFiltersContainerProps = {
  className?: string;
};

const GridsHistoryFiltersContainer = (ownProps: GridsHistoryFiltersContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(legacySelector);

  const setFilter = useCallback(
    (filterId) => {
      dispatch(setHistoryFilterAction(filterId));
    },
    [dispatch],
  );

  const otherProps = useMemo(() => ({ setFilter }), [setFilter]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsFilters {...enhancedProps} />;
};

export default GridsHistoryFiltersContainer;
